import { DataBean } from "../DataBean";

export class Annually extends DataBean {

    public async addAnnuallyPayrollFactor(idPayrollFactor: any, year: any, idInfoForTaxCertificate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.employees.AnnuallyPayrollFactor_addAnnuallyPayrollFactor_Number_Number_Number", [idPayrollFactor, year, idInfoForTaxCertificate]);
    }

}